
jQuery(document).ready(function() {

  $('.close').on('click', function(){
    $(this).parents('.wrapper-newsletter').css('display','none');
  });

  $('.slider-images').on('init', function(event, slick){
    $(this).css({
      opacity:1,
      height:'auto',
      visibility:'visible'
    });
  })
  $('.slider-images').slick({
    infinite: true,
    fade:true,
    arrows:false,
    speed:0,
    pauseOnFocus:false,
    pauseOnHover:false,
    autoplay:true,
    autoplaySpeed:5000,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  var basePath = window.location.origin;
  var animationPath = basePath + '/cdn/shop/t/4/assets/data.json';

  // const animationPath = "{{ 'data.json' | asset_url }}";

  var animation = lottie.loadAnimation({
    container: document.getElementById('logo-tintino'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: animationPath
  });
  // function playWithDelay() {
  //   animation.goToAndPlay(0, true);
  // }
  // setTimeout(playWithDelay, 10000);
  // animation.addEventListener('complete', function () {
  //   setTimeout(playWithDelay, 10000); // 10s delay between loops
  // });

  if($('.wrapper-newsletter').length) {
   function checkCookieConsent() {
     const consent = getCookie('signup-closed');
     // Check if the user has already acknowledged cookies
     if (consent === 'true') {
       // If consent is given, hide the banner
       document.getElementById('tt-newsletter').style.display = 'none';
     } else {
       // If no consent, show the banner
       document.getElementById('tt-newsletter').style.display = 'block';
     }
   }
   function getCookie(name) {
     const value = `; ${document.cookie}`;
     const parts = value.split(`; ${name}=`);
     if (parts.length === 2) return parts.pop().split(';').shift();
     return null;
   }
   function setCookie(name, value, days) {
     const d = new Date();
     d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000)); // expires in 'days' days
     const expires = `expires=${d.toUTCString()}`;
     document.cookie = `${name}=${value}; ${expires}; path=/`;
   }
   // let hasScrolled = false;
   // const scrollThreshold = 10; // Scroll distance in pixels
   // window.onscroll = function() {
   //   if (!hasScrolled && window.scrollY > scrollThreshold) {
   //     document.getElementById('tt-newsletter').style.display = 'none';
   //     hasScrolled = true;
   //     setCookie('signup-closed', 'true', 7);
   //   }
   // };
   document.getElementById('close-newsletter').addEventListener('click', function() {
     setCookie('signup-closed', 'true', 7); // Cookie will last for 7 days
     document.getElementById('tt-newsletter').style.display = 'none';
   });
   window.onload = function() {
     checkCookieConsent();
   };
  }



});
